import React, { useState } from 'react';

import { Box, Text } from '@components/Restyle';

const SKILLS_WIDTH_ORIGINAL = 234;

type SkillItem = { id: string; name: string };

export type PopupHiddenSkills1Props = {
  showHiddenSkillsFirstIndex: number;
  skills: SkillItem[];
  /**
   * When true: vertical layout, each skill on its own line, flexible width to wrap content.
   * When false: original row layout with fixed width (234px) and maxWidth constraints.
   */
  oneSkillPerLine?: boolean;
};

export const PopupHiddenSkills: React.FC<PopupHiddenSkills1Props> = ({
  showHiddenSkillsFirstIndex,
  skills,
  oneSkillPerLine = false,
}) => {
  const [skillWidth100, setSkillWidth100] = useState(0);

  const getHiddenSkills = () => {
    if (showHiddenSkillsFirstIndex === 0) return;
    const hiddenSkills = [];
    const hiddenSkillsLength = skills.length - showHiddenSkillsFirstIndex;

    const moreThanThreeSkill =
      hiddenSkillsLength > 3 ? (
        <Box
          marginBottom='xs'
          padding='xxs'
          borderRadius='xxs'
          borderColor='grey01'
          backgroundColor='white'
          alignSelf={oneSkillPerLine ? 'flex-start' : undefined}
          onLayout={
            !oneSkillPerLine
              ? (e) => setSkillWidth100(e.nativeEvent.layout.width)
              : undefined
          }>
          <Text variant='bodyTaskName' color='textPrimary' numberOfLines={1}>
            {'+' + (hiddenSkillsLength - 3)}
          </Text>
        </Box>
      ) : undefined;

    for (let i = showHiddenSkillsFirstIndex; i < skills.length; i++) {
      if (i < showHiddenSkillsFirstIndex + 3) {
        const skillBoxProps = oneSkillPerLine
          ? {
              key: skills[i].id,
              alignSelf: 'flex-start' as const,
              marginRight: 'xs' as const,
              marginBottom: 'xs' as const,
              padding: 'xxs' as const,
              borderRadius: 'xxs' as const,
              borderColor: 'grey01' as const,
              backgroundColor: 'white' as const,
            }
          : {
              key: skills[i].id,
              maxWidth:
                i < showHiddenSkillsFirstIndex + 2
                  ? SKILLS_WIDTH_ORIGINAL - 24
                  : SKILLS_WIDTH_ORIGINAL - 24 - skillWidth100 - 8 - 1,
              marginRight: 'xs' as const,
              marginBottom: 'xs' as const,
              padding: 'xxs' as const,
              borderRadius: 'xxs' as const,
              borderColor: 'grey01' as const,
              backgroundColor: 'white' as const,
            };

        hiddenSkills.push(
          <Box {...skillBoxProps}>
            <Text variant='bodyTaskName' color='textPrimary' numberOfLines={1}>
              {skills[i].name}
            </Text>
          </Box>
        );
      } else if (i === showHiddenSkillsFirstIndex + 3) {
        hiddenSkills.push(moreThanThreeSkill);
      }
    }
    return hiddenSkills;
  };

  const containerProps = oneSkillPerLine
    ? {
        flexDirection: 'column' as const,
        borderRadius: 'xs' as const,
        backgroundColor: 'grey05' as const,
        padding: 's' as const,
        paddingBottom: 'xxs' as const,
        alignSelf: 'flex-start' as const,
        minWidth: 132,
        maxWidth: 320,
      }
    : {
        flex: 1,
        width: SKILLS_WIDTH_ORIGINAL,
        flexDirection: 'row' as const,
        flexWrap: 'wrap' as const,
        borderRadius: 'xs' as const,
        backgroundColor: 'grey05' as const,
        padding: 's' as const,
        paddingBottom: 'xxs' as const,
      };

  return <Box {...containerProps}>{getHiddenSkills()}</Box>;
};
